export default __webpack_public_path__ + "static/media/banner.059e3ea1.jpg";